import { BigNumber } from 'ethers'
import { formatCurrency } from '../../model'

export function formatPoolMinimumTVL(poolMinimumTVL?: number) {
  if (!poolMinimumTVL) {
    return '-'
  }

  poolMinimumTVL = Math.ceil(poolMinimumTVL)

  if (poolMinimumTVL >= 1000000) {
    return `$${formatCurrency(2, BigNumber.from(poolMinimumTVL).div(10000))}M`
  } else if (poolMinimumTVL >= 1000) {
    return `$${formatCurrency(0, BigNumber.from(poolMinimumTVL).div(1000))}K`
  } else {
    return `$${formatCurrency(0, BigNumber.from(poolMinimumTVL))}`
  }
}
